// src/pages/Reports/IssuanceReporting/IssuanceStock/index.tsx
// README.md mục 7 — trang "Phát hành & Tồn kho", gộp 4 báo cáo cùng chủ đề bằng tab con:
// RPT-001 (tổng hợp phát hành), RPT-002 (chi tiết theo dải), RPT-003 (nhập từ nhà in),
// RPT-004 (tồn kho). Dữ liệu đọc trực tiếp từ ticket-service, không có Redux slice riêng — đúng
// pattern src/pages/Reports/AgentDebtReport (chỉ đọc, không thao tác tạo/sửa/xoá ở các tab này).

import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Container, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

import BreadCrumb from 'Components/Common/BreadCrumb';
import { useBrandingTitle } from 'hooks';
import IssuanceSummaryTab from './IssuanceSummaryTab';
import IssuanceRangeTab from './IssuanceRangeTab';
import PrintHouseReceiptsTab from './PrintHouseReceiptsTab';
import StockTab from './StockTab';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

type TabKey = 'summary' | 'range' | 'printHouseReceipts' | 'stock';

const TABS: { key: TabKey; label: string }[] = [
  { key: 'summary', label: st('tong_hop_phat_hanh_label') },
  { key: 'range', label: st('chi_tiet_theo_dai_label') },
  { key: 'printHouseReceipts', label: st('nhap_tu_nha_in_label') },
  { key: 'stock', label: st('ton_kho_label') },
];

const IssuanceStockPage: React.FC = () => {
  useBrandingTitle(st('phat_hanh_ton_kho_text'));
  const [activeTab, setActiveTab] = useState<TabKey>('summary');

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={st('phat_hanh_ton_kho_text')} pageTitle={st('bao_cao_phat_hanh_text')} />

        <Card>
          <CardHeader className="card-header border-0">
            <Nav tabs className="nav-tabs-custom card-header-tabs flex-wrap">
              {TABS.map((tab) => (
                <NavItem key={tab.key}>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === tab.key })}
                    onClick={(e) => { e.preventDefault(); setActiveTab(tab.key); }}
                  >
                    {tab.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </CardHeader>
          <CardBody>
            {activeTab === 'summary' && <IssuanceSummaryTab />}
            {activeTab === 'range' && <IssuanceRangeTab />}
            {activeTab === 'printHouseReceipts' && <PrintHouseReceiptsTab />}
            {activeTab === 'stock' && <StockTab />}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default IssuanceStockPage;
